import React from 'react';
import Img from './Img';
import { usePrematchData } from '../prematch/PrematchDataFetcher';
import { getTorneiInEvidenza, iconCategoryCssClass } from '../data/utils';
import Link from '../router/Link';
import { prematchPrefix } from '../Container';
import DraggableScroller from './DraggableScroller';
import { getLabel } from '../InitData';

export default function TopCompetitions() {
    const prematchData = usePrematchData();

    const data = getTorneiInEvidenza(prematchData.sport, 'ALL');
    const tournaments = data.tournamentsList;

    if (tournaments.length === 0) {
        return null;
    }

    return (
        <div className="c_12">
            <div className="c_12_1">{getLabel('general.top_tournaments')}</div>
            <DraggableScroller className="c_12_2">
                {tournaments.map(t => {
                    const sportDesc = prematchData.sportById[t.sportRef]?.descrizione ?? null;
                    const categoryIcon = iconCategoryCssClass(t.sportRef, t.categoryRef, t.categoryIcon);
                    return (
                        <Link key={t.uniqueId} href={`${prematchPrefix}/${t.urlPath}${t.urlPathSuffix}`} useDiv={true} className="c_12_2_1">
                            {t.backgroundImage ?
                                <img className="c_12_2_1_1" src={t.backgroundImage} height="96px" width="96px" />
                                :
                                <Img className="c_12_2_1_1" src="Football1.svg" height="96px" width="96px" />
                            }
                            <div className="c_12_2_1_2">
                                <div className="c_12_2_1_2_1">
                                    <div className={"c_12_2_1_2_1_1 " + categoryIcon}></div>
                                </div>
                                <div className="c_12_2_1_2_2">
                                    <span className="c_12_2_1_2_2_1">{sportDesc}</span>
                                    <span className="c_12_2_1_2_2_2">{t.descrizione}</span>
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </DraggableScroller>
        </div>
    );
}
